/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  StoryControllerMock,
  StoryControllerMockInterface,
} from "../StoryControllerMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        internalType: "uint80",
        name: "heroId",
        type: "uint80",
      },
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
    ],
    name: "heroPage",
    outputs: [
      {
        internalType: "uint16",
        name: "pageId",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "objectId",
        type: "uint32",
      },
      {
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
    ],
    name: "isStoryAvailableForHero",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        internalType: "uint80",
        name: "heroId",
        type: "uint80",
      },
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "pageId",
        type: "uint16",
      },
    ],
    name: "setHeroPage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "objectId",
        type: "uint32",
      },
      {
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
    ],
    name: "setIsStoryAvailableForHero",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
    ],
    name: "setSkippableStory",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
      {
        internalType: "uint32",
        name: "objectId",
        type: "uint32",
      },
      {
        internalType: "uint256",
        name: "stageId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "kill",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "completed",
            type: "bool",
          },
          {
            internalType: "address",
            name: "heroToken",
            type: "address",
          },
          {
            internalType: "address[]",
            name: "mintItems",
            type: "address[]",
          },
          {
            internalType: "int32",
            name: "heal",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaRegen",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "lifeChancesRecovered",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaConsumed",
            type: "int32",
          },
          {
            internalType: "uint32",
            name: "objectId",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "experience",
            type: "uint32",
          },
          {
            internalType: "uint256",
            name: "heroTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "iteration",
            type: "uint256",
          },
          {
            internalType: "uint32[]",
            name: "rewriteNextObject",
            type: "uint32[]",
          },
        ],
        internalType: "struct IGOC.ActionResult",
        name: "results",
        type: "tuple",
      },
    ],
    name: "setStoryAction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
    ],
    name: "skippableStory",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
      {
        internalType: "uint32",
        name: "objectId",
        type: "uint32",
      },
      {
        internalType: "uint256",
        name: "stageId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "iteration",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "storyAction",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "kill",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "completed",
            type: "bool",
          },
          {
            internalType: "address",
            name: "heroToken",
            type: "address",
          },
          {
            internalType: "address[]",
            name: "mintItems",
            type: "address[]",
          },
          {
            internalType: "int32",
            name: "heal",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaRegen",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "lifeChancesRecovered",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaConsumed",
            type: "int32",
          },
          {
            internalType: "uint32",
            name: "objectId",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "experience",
            type: "uint32",
          },
          {
            internalType: "uint256",
            name: "heroTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "iteration",
            type: "uint256",
          },
          {
            internalType: "uint32[]",
            name: "rewriteNextObject",
            type: "uint32[]",
          },
        ],
        internalType: "struct IGOC.ActionResult",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class StoryControllerMock__factory {
  static readonly abi = _abi;
  static createInterface(): StoryControllerMockInterface {
    return new Interface(_abi) as StoryControllerMockInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): StoryControllerMock {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as StoryControllerMock;
  }
}
